import { AuthGuard } from "../guards/auth-guard.service";
import { AccountSettingsComponent } from "./account-settings.component";
import { AccountSettingsResolve } from "./account-settings-resolve.service";
var ɵ0 = { name: 'account-settings' };
var routes = [
    // {
    //     path: 'account',
    //     pathMatch: 'prefix',
    //     redirectTo: 'account/settings'
    // },
    {
        path: 'account/settings',
        component: AccountSettingsComponent,
        resolve: { resolves: AccountSettingsResolve },
        canActivate: [AuthGuard],
        data: ɵ0,
    },
];
var AccountSettingsRoutingModule = /** @class */ (function () {
    function AccountSettingsRoutingModule() {
    }
    return AccountSettingsRoutingModule;
}());
export { AccountSettingsRoutingModule };
export { ɵ0 };



// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/account-settings/account-settings-routing.module.ts.pre-build-optimizer.js